import styled from 'styled-components'

import Link from '../Link'

const SubmarketButton = styled(Link)`
  padding: 0;

  position: relative;
  overflow: hidden;
  width: 36px;
  height: 36px;
  color: ${props => props.theme.fontColorWithBackground[props.type || 'primary']};
  text-decoration: none;
  font-size: 0.8em;
  justify-content: center;

  &:hover {
    text-decoration: none;
  }

  svg {
    color: ${props => props.theme.colors[props.type || 'primary']};
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export default SubmarketButton
